export { default } from './CanaisAtendimentoQrcode';
